import ProjectNotesWrapper from "@/pages/contracten/notities/ProjectNotesWrapper"
import { checkPermissions } from "@/utils/checkPermissions"
import { createFileRoute, useParams } from "@tanstack/react-router"

export const Route = createFileRoute(
  "/beheer/contracten/$contractId/notities/",
)({
  component: RouteComponent,
  beforeLoad: () => checkPermissions("read", "projects"),
})

function RouteComponent() {
  const { contractId } = useParams({
    from: "/beheer/contracten/$contractId",
  })

  return <ProjectNotesWrapper projectId={Number(contractId)} />
}
